import API from "../BaseURL";

const configJson = {
    headers: {
      "content-type": "application/json",
    },
  };


export async function getAllModems() {
    const res = API.get(`/modems/`, configJson);
    return res;
}

export async function getModemInfo(modem_id) {
    const res = API.get(`/modems/${modem_id}`, configJson);
    return res;
}


export async function createModem(data) {
    const res = API.post(`/modems/`, data, configJson);
    return res;
}


export async function updateModem(modem_id, data) {
    const res = API.put(`/modems/${modem_id}/`, data, configJson);
    return res;
}


export async function deleteModem(modem_id) {
    const res = API.delete(`/modems/${modem_id}/`, configJson);
    return res;
}


export async function getModemByExploitation(exploitation_id) {
    const res = API.get(`/modems/exploitation/${exploitation_id}`, configJson);
    return (await res).data;
}